import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import messages from './messages'

import API from 'utils/api/api'
import APIURL from 'utils/api/urls'
import IndicatorTools from 'utils/indicators/indicatorTools'

import Error from 'components/Error'
import Loading from 'components/Loading'

class ContentChartTitle extends Component {
  constructor(props) {
    super(props)

    const {
      intl: { formatMessage }
    } = props
    this.formatMessage = formatMessage

    this.state = {
      loading: true,
      error: false
    }
  }

  componentDidMount() {
    this.getIndicator()
  }

  getIndicator({ indicator } = { indicator: this.props.indicator }) {
    API.getQuery(APIURL.getIndicator(indicator))
      .then(data => IndicatorTools.getDataFromSingleIndicator(data))
      .then(indicatorData => this.setState({ indicatorData, loading: false, error: false }))
      .catch(reason => this.setState({ loading: false, error: true }))
  }

  renderIfAllOK() {
    let renderingComponent = null
    if (this.state.error) {
      renderingComponent = <Error />
    } else if (this.state.loading) {
      renderingComponent = <Loading />
    } else {
      if (this.props.layer === 3) {
        let title
        if (this.props.chartType === 'evolutionAbsolute') title = this.formatMessage(messages.absoluteValuesEvolution)
        if (this.props.chartType === 'map') title = this.formatMessage(messages.map)
        renderingComponent = (
          <div className="panel-heading">
            <h3 className="panel-title">{title}</h3>
          </div>
        )
      } else {
        let indicatorData = this.state.indicatorData
        renderingComponent = (
          <div className="panel-heading">
            <h3 className="panel-title">{indicatorData.name}</h3>
          </div>
        )
      }
    }
    return renderingComponent
  }

  render() {
    return <React.Fragment>{this.renderIfAllOK()}</React.Fragment>
  }
}

export default injectIntl(ContentChartTitle)



// WEBPACK FOOTER //
// ./src/modules/Content/ContentChart/ContentChartTitle/ContentChartTitle.jsx